<template>
  <transition name="fade">
    <div v-if="show" class="tooltip" :style="style">
      <div class="cursor" v-if="hand"></div>
      <img src="@/assets/img/nurse.svg" alt="Nurse" v-if="avatar" />
      <span><slot></slot></span>

      <div class="arrow" v-if="!hand">
        <svg
          width="11"
          height="7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M5.5 6L12 -0.5L5.5 -4L-1 -0.5L5.5 6Z"
              fill="#fff"
              stroke="#33333C"
              stroke-width="2"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="11"
                height="7"
                fill="#fff"
                transform="matrix(1 0 0 -1 0 7)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    tWidth: Number,
    tBottom: Number,
    avatar: Boolean,
    hand: Boolean,
    centred: Boolean,
  },
  computed: {
    style: function() {
      if (this.hand) {
        return {
          width: this.tWidth + "px",
          bottom: this.tBottom + "px",
          left: 0,
        };
      } else {
        return {
          width: "auto",
          bottom: this.tBottom + "px",
          left: this.centred ? 50 + "%" : 0,
          transform: this.centred ? "translateX(-50%)" : "none",
          "white-space": "nowrap",
        };
      }
    },
  },
  data() {
    return {
      show: false,
    };
  },

  mounted: function() {
    if (this.avatar) {
      setTimeout(() => {
        this.show = true;
      }, 1000);
    } else {
      this.show = true;
    }
  },

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.tooltip {
  background: #fff;
  border-radius: 24px;
  padding: 8px;
  border: 2px solid $black;
  display: flex;
  align-items: center;
  position: absolute;
  box-shadow: 0px 4px 4px rgba(103, 103, 103, 0.15);
  // bottom: -72px;
  left: 0;
  pointer-events: none;
  z-index: 999;
  transition: ease 1s;

  span {
    color: $black;
    margin-left: 12px;
    font-weight: 600;
    text-transform: initial;
  }

  .cursor {
    position: absolute;
    top: -50px;
    left: 12px;
    background: url("../assets/img/hand.svg") no-repeat;
    width: 29px;
    height: 50px;
    animation: point 1s infinite;
  }

  .arrow {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -11px;
  }
}

.isHidden {
  opacity: 0;
}

@keyframes point {
  0%,
  100% {
    background-position: 0px 20px;
  }
  50% {
    background-position: 0px 0px;
  }
}
</style>
